import { basicApi } from '../utils/api';

export interface SolapiSendResponse {
  batchId: number;
  messageId: number;
  dispatchStatus: string;
}

export interface SmsSendRequest {
  to: string;
  from: string;
  smsTemplateId: number;
  variables?: Record<string, string>;
}

export interface AlimtalkSendRequest {
  to: string;
  templateId: string;
  channelId?: string;
  variables?: Record<string, string>;
}

export const sendSmsTemplate = async (body: SmsSendRequest) =>
  (await basicApi.post<SolapiSendResponse>('/solapi/send/sms', body)).data;

export const sendAlimtalkTemplate = async (body: AlimtalkSendRequest) =>
  (await basicApi.post<SolapiSendResponse>('/solapi/send/alimtalk', body)).data;

export const listAllSenderNumbers = async (): Promise<string[]> => {
  const first = (await basicApi.get<{ content: Array<{ senderNumber: string }>; totalPages: number }>('/solapi/sender-numbers', { params: { pg: 1, limit: 100 } })).data;
  const numbers = first.content.map(item => item.senderNumber);
  for (let pg = 2; pg <= first.totalPages; pg += 1) {
    const page = (await basicApi.get<typeof first>('/solapi/sender-numbers', { params: { pg, limit: 100 } })).data;
    numbers.push(...page.content.map(item => item.senderNumber));
  }
  return numbers;
};
